export type ReportPagination = { page: number; limit: number };

export interface ReportContactRow {
  id?: string;
  name?: string | null;
  company_name?: string | null;
  email?: string | null;
}

export interface ReportTicketRow {
  id?: string;
  title?: string | null;
  contact_id?: string | null;
  contact?: ReportContactRow | ReportContactRow[] | null;
}

export interface ReportUserRow {
  id?: string;
  email?: string | null;
  first_name?: string | null;
  last_name?: string | null;
}

export interface ReportTimeEntryBase {
  ticket?: ReportTicketRow | ReportTicketRow[] | null;
  user?: ReportUserRow | ReportUserRow[] | null;
  entry_type?: string | null;
  hours?: number | null;
  billable_rate?: number | null;
}

function unwrapRelation<T>(value: T | T[] | null | undefined): T | null {
  if (!value) return null;
  return Array.isArray(value) ? (value[0] ?? null) : value;
}

export function getEntryContactName(entry: ReportTimeEntryBase): string {
  const ticket = unwrapRelation(entry.ticket);
  const contact = unwrapRelation(ticket?.contact);
  return contact?.company_name || contact?.name || "Unknown Contact";
}

export function getEntryUserName(entry: ReportTimeEntryBase): string {
  const user = unwrapRelation(entry.user);
  const first = user?.first_name ?? "";
  const last = user?.last_name ?? "";
  if (first || last) return `${first} ${last}`.trim();
  return user?.email || "Unknown User";
}

export function getEntryTicketTitle(entry: ReportTimeEntryBase): string {
  const ticket = unwrapRelation(entry.ticket);
  return ticket?.title || "Unknown Ticket";
}

export function calculateBillableRevenue(
  entry: ReportTimeEntryBase,
  fallback: number | null = null
): number | null {
  if (entry.entry_type === "billable" && entry.billable_rate && entry.hours) {
    return entry.billable_rate * entry.hours;
  }

  return fallback;
}
